/** @format */

import Qs from "qs";
export default (() => {
    let config;

    config = {
        baseURL: "/sim-sys",
        method: "POST",
        transformResponse: [
            function(data) {
                return data;
            },
        ],
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        params: {},
        paramsSerializer: function(params) {
            return Qs.stringify(params);
        },
        data: {},
        timeout: 60000,
        withCredentials: false, // default
        responseType: "json", // default
        maxContentLength: 2000,
        validateStatus: function(status) {
            return status >= 200 && status < 300; // default
        },
        maxRedirects: 5, // default
    };
    return config;
})();